import createApi from './api';

export default class LocationSettingsService {
  constructor() {
    this.api = createApi({
      baseUrl: 'admin/locations',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async getLocationSettings(locationId) {
    return this.api.post('get', { location_id: locationId });
  }

  async updateLocationSettings(params) {
    return this.api.post('update', params);
  }
}
